import React from 'react'
import "../assets/styles/mission.css"
import "../assets/styles/style.css"
import "../assets/styles/change.css";

function Mission() {
  return (
    <div className='parent'>
  <h1 className='title'>CHANGE: BECAUSE WE CAN</h1>
  <p className='description'>
    In Nepal, students attend school and study a range of academic subjects — but how many are truly taught the values of the world we live in today? The truth is, not many. Young people often go through adolescence burdened by academic stress, peer pressure, and emotional confusion. Some even become victims of harassment, abuse, or bullying — and the most heartbreaking reality is that many don't even realize that what they're experiencing is wrong.
  </p>
  <p className='description'>This is where Change: Because We Can (CBWC), a flagship program of Kalpabriksha, steps in. Through engaging, youth-led, and interactive learning methods, CBWC introduces students to vital topics such as mental health, consent, reproductive rights, and digital safety. It shines a light on sensitive but essential issues — including harassment, abuse, and discrimination — and serves as a compassionate introduction to the LGBTQ+ community and their rights.
</p>
<p className='description'>Our team of trainers is composed of passionate young individuals aged 18-24, currently pursuing higher education in Law, Medicine, Engineering, Psychology, and Education. Among them are LGBTQ+ individuals and survivors of abuse who bring lived experiences and empathy to the classroom.
</p>
<p className='description'>The CBWC curriculum covers:
</p>
  <ol className="content-list">
    <li>1. Adolescence and Mental Health: Understanding emotional and psychological changes during teenage years</li>
    <li>2. Digital Safety: Learning how to stay safe online</li>
    <li>3. LGBTQ+ Awareness and Rights: Exploring gender, identity, and inclusion</li>
    <li>4. Harassment and Abuse: Recognizing, resisting, and reporting abuse</li>
    <li>5. Equality and Youth Advocacy: Standing against discrimination in all its forms</li>
  </ol>
  <p className='description'>
    At CBWC, we believe that informed youth are empowered youth — and change is possible, because we can.

  </p>
  <h1 className="section-title">Mission</h1>
  <ol className="content-list">
    <li>1. Promote behavioral learning and practical education among students.</li>
    <li>2. Make students aware of sensitive issues like harassment, abuse, and their existence in various shapes and forms.</li>
    <li>3. Introduce the concept of the LGBTQ+ community among students.</li>
    <li>4. Promote a healthy mental status and smooth adolescent growth in students.</li>
  </ol>
  <h1 className="section-title">Vision</h1>
  <span className="vision-text">
    The vision of this program is to decrease the cases of abuse seen in school students and normalize the 
    mental health complexities seen in an adolescent teen.
  </span>
</div>

  )
}

export default Mission